
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { NotificationItemProps } from ".";
import { loading, endLoading } from "store/notification";

interface ApiNotificationRemoveInputProps {
    ids: number[]
}

type ApiNotificationRemoveOutputProps = OutputBaseProps<{ item: NotificationItemProps; }>

export const apiNotificationRemove = async (data: ApiNotificationRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiNotificationRemoveOutputProps>("/api/notification/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};